module.exports = __webpack_public_path__ + "img/7.31c639aa.jpg";